import { cloneDeep } from 'lodash';
import { APIS } from '../constants/apis';
import { PostRecord } from './PostRecord';
import { GetUpdateDependencies } from '../../pages/private/online-antrag/OnlineAntrag';
import { get } from 'lodash';

export async function PushNotification(api: string, application: number) {
	let entries: any[] = [];
	if (api === APIS.Zuwendungsantrag) {
		let relations = cloneDeep(get(GetUpdateDependencies(application, api), 'relations', []));

		for (let ele of relations) {
			if (get(ele, 'api') === APIS.Organisation) {
				entries.push({ api: get(ele, 'api'), id: get(application, `${get(ele, 'field')}.id`) });
			}
		}
		entries.push({ api: APIS.Zuwendungsantrag, id: get(application, 'id') });
	}

	if (api === APIS.Mittelabruf) {
		entries.push({ api: APIS.Mittelabruf, id: get(application, 'id') });
	}

	if (api === APIS.Verwendungsnachweis) {
		entries.push({ api: APIS.Verwendungsnachweis, id: get(application, 'id') });
	}

	await PostRecord(APIS.PushNotificaiton, { data: { entities: entries } });
}
